import {useEffect, useState} from "react";
import axios from "axios";
import {SEARCH_AXIOS_TICKET_URL} from "../../../../services/utils/ApiUrls";
import {decriptMessage} from "../../../../utils/SecureData";

export default function useTicketSearch(query, pageNumber, loadingInitialValue = true) {
	const [loadingSearch, setLoading] = useState(loadingInitialValue);
	const [errorSearch, setError] = useState(false);
	const [ticketSearch, setTickets] = useState(sessionStorage.getItem("searchTicket") ? JSON.parse(sessionStorage.getItem("searchTicket")) : []); // useSessionStorage("ticketSearch", []) //
	const [hasMoreSearch, setHasMore] = useState(sessionStorage.getItem("hasMoreSearch") ? sessionStorage.getItem("hasMoreSearch") === "true" : false);//useSessionStorage("hasMore", false) //
	
	useEffect(() => {
		setTickets([]);
		sessionStorage.removeItem("searchTicket")
		if (query.length === 0) {
			sessionStorage.setItem("hasMoreSearch", "false")
			setHasMore(false);
		}
	}, [query])
	
	useEffect(() => {
		sessionStorage.removeItem("searchTicket")
	}, [])
	
	useEffect(() => {
		if (query.length > 0) {
			setLoading(true);
			setError(false);
			//let cancel
			axios({
				method: "GET",
				url: SEARCH_AXIOS_TICKET_URL + pageNumber,
				params: {
					search: query,
				},
				/*cancelToken: new axios.CancelToken(c => cancel = c),*/
				headers: {
					Authorization: "Bearer " + decriptMessage(sessionStorage.getItem("key_asl_to")),
				}
			}).then(response => {
				setHasMore(response.data.length > 0);
				sessionStorage.setItem("hasMoreSearch", ((response.data.length > 0) ? "true" : "false"));
				setTickets(prevState => {
					let newState = [...prevState, ...response.data];
					let filter = newState.filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)));
					sessionStorage.setItem("searchTicket", JSON.stringify(filter))
					return filter
				})
				setLoading(false);
			}).catch(() => {
				/*if (axios.isCancel(e)) return*/
				setError(true)
				setLoading(false);
			})
			
			/*return () => cancel()*/
		}
	}, [query, pageNumber, setHasMore, setTickets])
	
	return {loadingSearch, errorSearch, ticketSearch, hasMoreSearch};
}
